export function setImmediate(callback: () => unknown) {
  return setTimeout(callback, 0);
}
